/**
 * @deprecated
 * 
 * Instead, please use 
 * ```
 * m('input.form-check-input[type="checkbox"]')
 * ```
 */
export default function checkboxInputComponent() {
  return {
    view: ({ attrs }) => {
      return m('.d-flex.align-items-center',
        m('p',
          m('input[class="form-check-input me-2"][type="checkbox"]', {
            checked: attrs.value,
            value: attrs.value,
            onclick: attrs.onclick
          },
          )
        ),
        m('label.form-label.mb-3',
          attrs.label,
        )
      );
    }
  }
}
